import React, { useState } from "react";
import { useLanguage, T, pickBilingual } from "@/lib/i18n";
import { ArrowUpRight } from "lucide-react";

export default function Campaigns() {
  const { lang } = useLanguage();
  const [items, setItems] = useState([]);

  return (
    <section id="campaigns" data-testid="campaigns-section" className="bg-sjm-mist border-t border-sjm-line">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 sm:py-28 lg:py-32">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-sjm-red">{T.campaigns.eyebrow[lang]}</div>
            <h2 className={`mt-3 font-display font-extrabold tracking-tighter text-3xl sm:text-4xl lg:text-5xl text-sjm-ink ${lang === "bn" ? "font-bn" : ""}`}>
              {T.campaigns.title[lang]}
            </h2>
          </div>
          <div className="text-sm text-sjm-muted">{items.length} {lang === "bn" ? "টি আন্দোলন" : "campaigns"}</div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 bg-white border border-sjm-line rounded overflow-hidden">
            <div className="p-6">
              <div className="text-sm font-bold text-sjm-red uppercase tracking-wide">{lang === "bn" ? "কিছু বিষয়ে জোর দিতে হবে" : "Some issues we must emphasise"}</div>
              <h3 className={`mt-2 text-3xl font-display font-extrabold text-sjm-ink ${lang === "bn" ? "font-bn" : ""}`}>{lang === "bn" ? "আমাদের প্রয়োজন একটি UNIFIED PLATFORM" : "A UNIFIED PLATFORM we need"}</h3>

              <ul className="mt-6 space-y-4">
                {(T.campaigns.items && Array.isArray(T.campaigns.items[lang]) ? T.campaigns.items[lang] : []).map((it, idx) => (
                  <li key={idx} className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-sjm-ink text-white flex items-center justify-center font-bold">{idx + 1}</div>
                    <div className={`${lang === "bn" ? "font-bn text-base" : "text-base"} leading-relaxed text-sjm-ink`}>{it}</div>
                  </li>
                ))}
              </ul>

              <p className={`mt-6 text-sjm-muted ${lang === "bn" ? "font-bn" : ""}`}>{T.campaigns.statement[lang]}</p>
            </div>
          </div>

          <aside className="lg:col-span-1 space-y-4">
            <div className="bg-white border border-sjm-line rounded p-6">
              <h4 className={`font-bold mb-3 ${lang === "bn" ? "font-bn" : ""}`}>{lang === "bn" ? "আমাদের দাবিসমুহ" : "Our Demands"}</h4>
              <p className={`text-sm text-sjm-muted ${lang === "bn" ? "font-bn" : ""}`}>{T.campaigns.statement[lang]}</p>
            </div>

            <div className="bg-white border border-sjm-line rounded p-6 text-center">
              <div className="text-xs uppercase tracking-wide font-bold text-sjm-red">{lang === "bn" ? "যোগ দিন" : "Join"}</div>
              <div className={`mt-3 font-display font-extrabold text-xl ${lang === "bn" ? "font-bn" : ""}`}>{lang === "bn" ? "আমাদের সঙ্গে যুক্ত হন" : "Stand With Us"}</div>
              <div className="mt-4">
                <a href="#join" className="inline-block px-4 py-2 bg-sjm-red text-white rounded font-bold text-sm">{lang === "bn" ? "যোগ দিন" : "Join"}</a>
              </div>
            </div>
          </aside>
        </div>

        {/* keep existing campaign cards (from API) below */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {(Array.isArray(items) ? items : []).map((c, i) => (
            <article
              key={c.id}
              data-testid={`campaign-card-${i}`}
              className="group relative bg-white border border-sjm-line hover-lift overflow-hidden"
            >
              {c.image_url ? (
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={c.image_url} alt="" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                </div>
              ) : null}
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className={`text-[10px] font-bold uppercase tracking-[0.2em] px-2 py-1 ${c.status === "active" ? "bg-sjm-red text-white" : "bg-sjm-ink text-white"}`}>
                    {c.status === "active" ? T.campaigns.status_active[lang] : T.campaigns.status_past[lang]}
                  </span>
                </div>
                <h3 className={`font-display font-bold text-xl text-sjm-ink leading-tight ${lang === "bn" ? "font-bn" : ""}`}>
                  {pickBilingual(c, "title", lang)}
                </h3>
                <p className={`mt-3 text-sjm-muted text-sm leading-relaxed line-clamp-3 ${lang === "bn" ? "font-bn" : ""}`}>
                  {pickBilingual(c, "description", lang)}
                </p>
                <div className="mt-5 flex items-center gap-1 text-sjm-red font-bold text-xs uppercase tracking-wider">
                  {lang === "bn" ? "বিস্তারিত" : "Read more"}
                  <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
